import clsx from 'clsx';
import React, { useEffect } from 'react';
import { InView } from 'react-intersection-observer';

import { useEventTracking } from '@hooks/index';
import { TalentTrackerProps } from '@interfaces/projects';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';

import CategoryDropdown from './CategoryDropdown';
import MainContent from './MainContent';
import Paywall from './Paywall';
import TopSection from './TopSection';

const SIDEBAR_SECTION_TAKEAWAYS = 'takeaways';
const SIDEBAR_SECTION_READ_MORE = 'read more';

const TalentTracker = ({
  data,
  paywallData,
  project: { leadType, notes, slug, ...topSectionProps },
  unlocked,
}: TalentTrackerProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.TalentTracker,
  });

  useEffect(() => {
    trackEvent(impression({ impressionElement: ImpressionElement.Project }));
  }, [trackEvent]);

  const { categories, profiles, sidebarItems } = data;

  const takeaways = sidebarItems.filter((item) => item.section === SIDEBAR_SECTION_TAKEAWAYS);
  const readMoreItems = sidebarItems.filter((item) => item.section === SIDEBAR_SECTION_READ_MORE);

  return (
    <InView triggerOnce={true}>
      <main>
        <div className="px-28">
          <div className="mx-auto max-w-container-lg">
            <TopSection takeaways={takeaways} readMoreItems={readMoreItems} {...topSectionProps} />
            {categories.length > 1 && (
              <div className="mt-56 flex items-center gap-16 md:mt-112">
                <span className="font-suisse-intl text-button-lg">Category</span>
                <CategoryDropdown categories={categories} currentSlug={slug} />
              </div>
            )}
            {unlocked && (
              <MainContent
                className={clsx({
                  'mt-112': categories.length <= 1,
                  'mt-24': categories.length > 1,
                })}
                notes={notes}
                profiles={profiles}
                projectSlug={slug}
              />
            )}
          </div>
        </div>
        {!unlocked && <Paywall leadType={leadType} paywallData={paywallData} />}
      </main>
    </InView>
  );
};

export default TalentTracker;
